import {Select} from "@/theme";
import {useApi} from "@/lib/hook";

export const RolePermissionsSelect = ({userRoles, ...rest}) => {
    const {data} = useApi({
        route: {name: 'authorization.roles'},
        data: {
            include: 'permissions',
        },
        setting: {
            select: (resp) => resp.data,
            staleTime: Infinity,
        }
    })

    const setOptions = () =>{
        if (data && userRoles){
            const resp = data.find((item)=>userRoles.includes(item.name))

            return resp ? resp.permissions : []
        }

        return [];
    }

    const setValue = () =>{
        const resp = setOptions()

        return resp.map((item)=>item.name)
    }

    return (
        <>
            <Select
                mode={'multiple'}
                fieldNames={{value: 'name', label: 'title'}}
                options={setOptions()}
                value={setValue()}
                {...rest}
            />
        </>
    );
}